import React from "react";
import PageHeader from "../components/PageHeader";
import SEO from "../components/SEO";
import WhyChooseUs from "../components/WhyChooseUs";
import Brands from "../components/Brands";
import { introImage } from "../data/mock";
import { useQuote } from "../context/QuoteContext";
import { Check, ArrowRight } from "lucide-react";
import { SITE_URL } from "../lib/site";

const About = () => {
  const { openQuote } = useQuote();
  const points = [
    "Locally owned & operated in Rocky Mount, NC",
    "Veteran-owned and locally operated",
    "Certified, licensed and fully insured technicians",
    "Work with 80+ industry-leading brands",
  ];
  return (
    <main>
      <SEO
        title="About Us"
        description="Learn about Set Up Home Theater — your local, veteran-owned commercial & residential AV experts (TV, audio and home cinema installation) serving Rocky Mount and Nash County, North Carolina."
        path="/about"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
            { "@type": "ListItem", position: 2, name: "About Us", item: `${SITE_URL}/about` },
          ],
        }}
      />
      <PageHeader
        breadcrumb="Home / About Us"
        title="About Set Up Home Theater"
        subtitle="Your local experts in commercial & residential AV — TV, audio and home cinema installation across North Carolina."
      />
      <section className="section-pad">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="eyebrow">Who we are</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a1f44] mt-4 mb-5">
              Passionate about perfect installations
            </h2>
            <p className="text-slate-500 leading-relaxed mb-5">
              At Set Up Home Theater, we believe that great technology should be
              simple to enjoy. Led by Chris, our team of expert technicians has
              helped thousands of homeowners and businesses across Rocky Mount
              and Nash County bring their entertainment spaces to life — from
              flawless TV wall mounting to full custom home cinema builds.
            </p>
            <div className="space-y-3 mb-8">
              {points.map((p) => (
                <div key={p} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-[#eef4ff] flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5 text-[#3b9dff]" />
                  </span>
                  <span className="text-[#0a1f44] font-medium text-sm">{p}</span>
                </div>
              ))}
            </div>
            <button
              onClick={() => openQuote()}
              className="flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#3b9dff] text-white font-semibold hover:bg-[#2b8ae8] transition-colors"
            >
              Work with us <ArrowRight className="w-4 h-4" />
            </button>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img src={introImage} alt="Set Up Home Theater installation in a Rocky Mount NC living room" className="w-full h-[440px] object-cover" />
          </div>
        </div>
      </section>
      <WhyChooseUs />
      <Brands />
    </main>
  );
};

export default About;
